var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mx-1"},[_c('audio',{ref:_vm.msgData.messageUid,staticClass:"audio-player",attrs:{"controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }